import HydrantPagingResultModelBase from '../_generated/modelBases/hydrant-paging-result-model-base';

export default class HydrantPagingResultModel extends HydrantPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
